import React from 'react'
import { LOG_LEVEL_ERROR, logger_backend_service } from './redux/logger'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, response: '' }
  }

  static defaultProps = {
    message: 'Disculpe. Hubo un error inesperado',
    modulo: 'app',
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    if (error?.name === 'ChunkLoadError') {
      setTimeout(() => window.location.reload(), 3000)
      return {
        hasError: true,
        origError: error,
        error: new Error(
          'Hubo un cambio de versión de Asofix.\nEl navegador se refrescará en 3 segundos',
        ),
      }
    }
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    if (this.props.logout) {
      console.log("LOGOUT THROUGH ERROR BOUNDARY", error, errorInfo)
      this.timeout = window.setTimeout(() => {
        localStorage.clear()
        localStorage.setItem("test_logout", JSON.stringify({error, errorInfo}))
        window.location.href = '/logout'
      }, 7000)
    }

    if (error?.name === 'ChunkLoadError') return // ignore

    logger_backend_service(
      LOG_LEVEL_ERROR,
      this.props.modulo,
      this.props.message,
      error?.message,
      errorInfo,
      error?.stack,
    ).then(response => {
      this.setState({ response })
    })
  }

  render() {
    if (this.state.hasError || Boolean(this.props.error)) {
      return (
        <div className="alert alert-danger fluid-type-xl" role="alert">
          <p>{this.props.message}</p>
          <p>{this.state.error?.message || this.props.error?.message }</p>
          <p>{this.state.response}</p>
          {this.props.logout ? (
            <>
              <p>Intente ingresar con su usuario y contraseña devuelta</p>
              <p>Deslogueo de sistema automático en 7 segundos...</p>
            </>
          ) : null}
        </div>
      )
    }

    return this.props.children
  }
}

export function WithErrorBoundary(modulo = 'App', message, Component) {
  class WithErrorHandler extends React.Component {
    constructor(props) {
      super(props)
      this.state = { hasError: false, response: '' }
    }

    static defaultProps = {
      message: 'Disculpe. Hubo un error en este modulo',
    }

    static getDerivedStateFromError(error) {
      // Update state so the next render will show the fallback UI.
      if (error?.name === 'ChunkLoadError') {
        setTimeout(() => window.location.reload(), 3000)
        return {
          hasError: true,
          origError: error,
          error: new Error(
            'Hubo un cambio de versión de Asofix.\nEl navegador se refrescará en 3 segundos',
          ),
        }
      }
      return { hasError: true, error }
    }

    componentDidCatch(error, errorInfo) {
      if (error?.name === 'ChunkLoadError') return // ignore
      logger_backend_service(
        LOG_LEVEL_ERROR,
        modulo,
        message,
        error?.message,
        errorInfo,
        error?.stack,
      ).then(response => {
        this.setState({ response })
      })
    }

    render() {
      if (this.state.hasError) {
        return (
          <div className="alert alert-danger fluid-type-xl" role="alert">
            <p>{this.props.message}</p>
            <p>{this.state.error?.message}</p>
            <p>{this.state.response}</p>
          </div>
        )
      }

      return (
        <div key={this.props.location.pathname} className="route-fade-in">
          <Component {...this.props} />
        </div>
      )
    }
  }
  WithErrorHandler.displayName = `withErrorHandler(${Component.displayName})`
  return WithErrorHandler
}
